import {
  JobStyleDataItem,
  JobStyleDataResponse,
} from "@/hooks/queries/useJobStyleDataQuery";
import {
  JobStyleDataItemAggregated,
  JobStyleDataResponseAggregated,
} from "@/hooks/queries/useJobStyleDateAggregatedQuery";
import { SkuData, StyleIdDataAggregated } from "@/types/common.types";
import { flattenData } from "@/utils/dataTransformers";

export const getSkuData = (data: JobStyleDataResponse | null) => {
  if (!data) return [];
  return data.data.reduce((acc: SkuData[], curr: JobStyleDataItem) => {
    acc.push(...flattenData(curr.pdpData));
    return acc;
  }, []);
};

export const getSkuDataAggregated = (
  data: JobStyleDataResponseAggregated | null
) => {
  if (!data) return [];
  return data.data.reduce(
    (acc: StyleIdDataAggregated[], curr: JobStyleDataItemAggregated) => {
      acc.push(curr.pdpData);
      return acc;
    },
    []
  );
};
